import { parseISO } from 'date-fns'

import type { Seminar } from 'services/seminars/types'
import {
  formatStartEndDate,
  formatDate,
} from 'ui-component-library/utils/helpers'
import style from './style.scss'

type Props = {
  className?: string
  seminar: Seminar
}

function DateTimeTableCell({ seminar, className }: Props) {
  const date = formatStartEndDate(
    parseISO(seminar.startDate),
    parseISO(seminar.endDate),
    true,
  )

  const timezone = seminar.isOnlineSeminar ? ' PT' : ''
  const time =
    formatDate(seminar.startDate, 'h:mma') +
    ' - ' +
    formatDate(seminar.endDate, 'h:mma') +
    timezone

  return (
    <td className={className}>
      <div className={style.date}>{date}</div>
      <div>{time}</div>
    </td>
  )
}

export default DateTimeTableCell
